module.exports = "/_next/static/images/WirelineHero-e7729c5a523120cbdef7db01b04a4d1d.webp";